import React, { useState } from 'react'
import * as actions from '../../actions/PlanDeEmbarqueActions'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { renderSelectField, renderTextField } from '../../../Forms/fieldRenderers'
import { Row, Col } from 'react-bootstrap'
import { CerealVariedadDropdown } from '../../../Forms/SharedComponents/containers'
import PaisDropdown from '../../../Forms/SharedComponents/containers/PaisDropdown'
import { FORM_PLAN_DE_EMBARQUE } from '../../../../config/forms'

function CamposPlanDeEmbarque (props) {
  const { bodegas, detalleInicial = null } = props
  const [peso, setPeso] = useState(0)
  const [selectedBodega, setSelectedBodega] = useState('')

  const renderBodegas = () => {
    const options = bodegas && bodegas.map((b) => {
      return (
        <option
          value={b.nombre}
          key={b.nombre}
        >
          {b.nombre}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  return (
    <div style={{ padding: '8px' }}>
      <Row>
        <Col md={5}>
          <CerealVariedadDropdown required cerealInicial={detalleInicial ? detalleInicial.cereal : null} />
        </Col>
        <Col md={3}>
          <Field
            onChange={(b) => setSelectedBodega(b)}
            name='bodega'
            label='Bodega *'
            autoFocus={false}
            component={renderSelectField}
            value={selectedBodega}
          >
            {renderBodegas()}

          </Field>
        </Col>
        <Col md={2}>
          <Field
            // autoOk
            name='peso'
            label='Peso (Kg.) *'
            component={renderTextField}
            value={peso}
            onChange={(t) => { setPeso(t.target.value) }}
          />
        </Col>
        <Col md={2}>
          <PaisDropdown label='Pais destino *' name='paisDestino' />
        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = (state) => ({
  bodegas: state.buque.bodegas
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PLAN_DE_EMBARQUE,
  enableReinitialize: true
})

export default withRedux(withReduxForm(CamposPlanDeEmbarque))
